const navBtnBase = {
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  width: 44,
  height: 44,
  borderRadius: "50%",
  background: "rgba(255,255,255,0.9)",
  border: "none",
  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  color: "#1e293b",
  zIndex: 2,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "all 0.2s ease",
};

export const carouselPt = {
  root: { style: { display: "flex", flexDirection: "column" } },
  content: { style: { overflow: "hidden" } },
  container: { style: { position: "relative" } },
  itemsContent: { style: { padding: 0 } },
  itemsContainer: { style: { padding: 0, margin: 0, gap: 0 } },
  item: { style: { padding: 0, flex: '1 0 100%' } },
  previousButton: { style: { ...navBtnBase, left: "min(1vw, 1rem)" }, className: "carrusel-nav-btn" },
  nextButton: { style: { ...navBtnBase, right: "min(1vw, 1rem)" }, className: "carrusel-nav-btn" },
  indicators: { style: { display: "flex", justifyContent: "center", gap: "min(0.5vw, 0.5rem)", padding: "min(0.8vw, 0.8rem) 0 0", listStyle: "none", margin: 0 } },
  indicator: {
    className: "carrusel-ind-wrap",
    style: { listStyle: "none" },
  },
};
